<template>
  <section class="page-container">
    <div
      class="filter-bar"
      :class="{
        'blue-bg': diff,
        'border-bottom-radius': !showFilterCard}">
      <div class="main-left">
        <div class="left">
          <font-awesome-icon
            icon="filter"
            class="icon icon-filter"></font-awesome-icon>
          <span class="text">Filter</span>
        </div>
        <div class="filter-status">
          <span
            v-for="(item, i) in statusList"
            :key="i"
            class="status-item">
            <span class="status-title">
              {{item.title}}:
            </span>
            <span class="content">
              {{item.content}}
            </span>
          </span>
        </div>
      </div>
      <div class="right">
        <div
          v-if="diff"
          class="translucence"></div>
        <div class='right-content'>
          <font-awesome-icon
            v-show="diff"
            icon="rotate-left"
            class="icon icon-rotate pointer"
            @click="resetFilter"></font-awesome-icon>
          <font-awesome-icon
            v-if="showFilterCard"
            icon="square-minus"
            class="icon pointer"
            @click="showFilterCard = false"></font-awesome-icon>
          <font-awesome-icon
            v-else
            icon="square-plus"
            class="icon pointer"
            @click="showFilterCard = true"></font-awesome-icon>
        </div>
      </div>
    </div>
    <div
      v-show="showFilterCard"
      class="filter-card border-bottom-radius">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Active Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Referrered Code</span>
            <v-input
              v-model="referrer_code"
              @change="filterData"></v-input>
          </div>
          <div class="form-item">
            <span>Trial Code</span>
            <v-input
              v-model="trial_code"
              @change="filterData"></v-input>
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Type
              <span
                class="all"
                @click="handlerSelectAll('type')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('type')">None</span>
            </span>
            <v-checkbox-group
              v-model="type"
              :list="userTypeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options black">
                    {{ item['name'] }}
                  </span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>
              Tags
              <span
                class="all"
                @click="handlerSelectAll('tags')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('tags')">None</span>            </span>
            <div class="flex-column">
              <v-checkbox
                v-model="tier_base"
                :isBoolean="false"
                class="diamond-status"
                @change="filterData"
              >Professional</v-checkbox>
              <v-checkbox
                v-model="is_blocked"
                :isBoolean="false"
                class="blocked-status"
                @change="filterData"
              >Blocked</v-checkbox>
            </div>
          </div>
        </div>
        <div class="filter-last">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('status')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('status')">None</span>
            </span>
            <v-checkbox-group
              v-model="status"
              :list="statusExpiryOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-status"
                    :class="{
                      'red': item.id == 3,
                      'green-trans': item.id == 2
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'">
        <el-table-column
          width="10"
        >
        </el-table-column>
        <el-table-column
          prop="id"
          width="45"
        >
          <template #default="{row}">
            <font-awesome-icon
              :class="{'orange': row.is_flagged}"
              :icon="row.is_flagged? 'person-circle-exclamation' : 'user'" />
          </template>
        </el-table-column>
        <el-table-column
          width="95px"
          label="Active Date">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.effective_date.split(" ")[0] }}</span><br>
              <span> {{ row.effective_date.split(" ")[1] }}</span>
              <!--              </span>-->
            </div>
          </template>

        </el-table-column>
        <el-table-column
          width="95px"
          label="Membership End date">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <span>{{ row.expired_date.split(" ")[0] }}</span><br>
              <span> {{ row.expired_date.split(" ")[1] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="identity_language"
          width="100">
          <template  #default="{ row }">
            <span  class="span-status type-status">{{ row.identity_language }}</span>
            <span class="flex mg-t-3">
              <span
                class="span-status"
                :class="{
                  'red': row.status == 3,
                  'green-trans': row.status == 2
                }">{{ row.status_language }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Name">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="first-text weight-text">
                {{ row.isrd_nm != ' '? row.isrd_nm : 'Unnamed Account'}}
              </span>
              <p class="liter-text">#{{ row.id }}</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Tel/email">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">{{ row.registered_login }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Trial Code">
          <template #default="{ row }">
            <div class="flex-algin">
              <p class="first-text">{{ row.base_code }} </p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Referrered by">
          <template #default="{ row }">
            <div class="flex-algin">
              <span class="span-name">{{ row.referrer_isrd_nm }}</span>
              <p class="liter-text">{{row.referrer_code }}</p>
            </div>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          width="89px"-->
        <!--          label="Fee"-->
        <!--          prop="referrer_nm">-->
        <!--          <template #default="{ row }">-->
        <!--            <div class="flex-algin">-->
        <!--              <p class="first-text">-->
        <!--                <span-->
        <!--                  v-if="row.referrer_id != 0 && row.referrer_nm.trim() === ''"-->
        <!--                  class="unname">Unnamed</span>-->
        <!--                <span v-if="row.referrer_id != 0">{{ row.referrer_nm }}</span>-->
        <!--              </p>-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinMarketing from '@/mixins/marketing'


export default {
  name: 'professtional',
  mixins: [MixinMarketing],
  props:{
    isFulfilled:{
      type:Boolean,
      default:false
    },
    isList:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      date: [],
      referrer_code: '',
      statusList: [],
      showFilterCard: true,
      tier_base: 1,
      is_blocked: 0,
      type:[],
      status:[2],
      trial_code:'',
      defaultFilter:{
        date: [],
        type:[],
        tier_base: 1,
        is_blocked: 0,
        referrer_code:'',
        trial_code:'',
        status:[2],
      },
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/marketing/marketing';

</style>
